<se-fe-card>
  <se-po-persona-avatar
    class="persona-avatar"
    headerDataSize="500"
    [persona]="persona">
  </se-po-persona-avatar>
  <se-fe-card-content>
    <se-fe-chip-group class="contact-section-content">
      @if (primaryEmailDisplay) {
        <se-fe-chip
          [seFeDataText]="primaryEmailDisplay"
          seFeDataIconLeft="envelope_filled">
        </se-fe-chip>
      }
      @if (primaryPhoneDisplay) {
        <se-fe-chip
          [seFeDataText]="primaryPhoneDisplay | phone"
          seFeDataIconLeft="phone_fill">
        </se-fe-chip>
      }
    </se-fe-chip-group>
  </se-fe-card-content>
</se-fe-card>
